// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1tsFw","inner":"Form_inner__1kuG9","range":"Form_range__1_8rC","name":"Form_name__3yWpY","actions":"Form_actions__8_vmc"};